<script lang="ts" setup>
/* eslint-disable vue/no-v-html */

export type PageHeaderPerexProps = {
    description: string
    cta?: CTA
}

const props = defineProps<PageHeaderPerexProps>()
const linkUrl = computed<VNuxtLinkTo>((): VNuxtLinkTo => {
    if (!props.cta?.link) return null

    if (props.cta?.link_type === 'form') {
        const [id, search] = props.cta.link.split('?')
        const query = search
            ? Object.fromEntries(new URLSearchParams(`${search}`))
            : {}

        return {
            name: 'online-services-detail',
            params: { id },
            query,
        }
    }

    return props.cta.link
})
</script>

<template>
  <ContainerFluid>
    <Tracker :data="{ title: props.cta?.text || '' }">
      <div
        class="page-header-perex position-relative bg-white rounded px-4 py-6 p-md-12 mb-10"
        data-cy="header_perex"
      >
        <div class="row align-items-md-center justify-content-between">
          <Typo
            class="col-12"
            :class="{ 'col-lg-8': props.cta?.link }"
          >
            <div
              class="text-black fs-smaller fs-md-bigger"
              :class="{
                'mb-5 mb-lg-0': props.cta?.link,
                'mb-0': !props.cta?.link,
              }"
              v-html="props.description"
            />
          </Typo>
          <div
            class="flex-grow-1 flex-md-grow-0 col-auto col-lg-4 col-xl-3 d-lg-flex justify-content-end"
          >
            <VButton
              v-if="props.cta?.link"
              :target="props.cta.isExternal ? '_blank' : '_self'"
              :to="linkUrl"
              :label="linkUrl"
              class="w-100"
              size="large"
              color="primary"
            >
              {{ props.cta.text }}
            </VButton>
          </div>
        </div>
      </div>
    </Tracker>
  </ContainerFluid>
</template>

<style lang="scss" scoped>
@import 'PageHeaderPerex.scss';
</style>
